import { BannerParam } from 'app/modules/settings/domain/entity/BannerParam';
import { BannerParamResponse } from 'app/modules/settings/infrastructure/dto/response/BannerParamResponse';
import { BannerParamRequest } from 'app/modules/settings/infrastructure/dto/request/BannerParamRequest';
import { BannerParamId } from 'app/modules/settings/domain/valueObject/BannerParamId';
import { BannerParamKey } from 'app/modules/settings/domain/valueObject/BannerParamKey';
import { BannerParamValue } from 'app/modules/settings/domain/valueObject/BannerParamValue';

export class BannerParamMapper {

    public static toDomain(bannerParamResponse: BannerParamResponse): BannerParam {
        return new BannerParam(
            new BannerParamId(bannerParamResponse.id),
            new BannerParamKey(bannerParamResponse.key),
            new BannerParamValue(bannerParamResponse.value),
        );
    }

    public static fromDomain(bannerParam: BannerParam): BannerParamRequest {
        return {
            id: bannerParam.id.value,
            key: bannerParam.key.value,
            value: bannerParam.value.value,
        };
    }

}
